module.exports = __webpack_public_path__ + "img/account_details.61d35361.svg";